import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IAppCoreState } from '..';

const selectAppCoreState = createFeatureSelector<IAppCoreState>('AppCoreState');



export const getAuthData = createSelector(
    selectAppCoreState,
    state => state.AuthData.AuthData
);
  
// renamed from getDealerFeatures
export const getAuthAccess = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.dealerFeatures
);

// Selector to get User Info
export const getUserInfo = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.userInfo
);

export const getCrmInfo = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.crmInfo
);

export const getCreditData = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.creditData
);
  
export const getCustomViewData = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.customViews
);
export const getCustomLogView = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.logView
);

export const updateCustomViewData = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.customViews
);

export const getMyTeams = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.myTeams
);
export const getAllSalesConsultants = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.salesConsultant
);

export const getSalesConsultant = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.salesConsultant
);

export const getSalesConsultantResponse = createSelector(
    selectAppCoreState,
    state => state.AuthAccessData.salesConsultantResponse
);

export const getAppNavBar =  createSelector(
    selectAppCoreState, 
    state => state.navbar
);

// export const getWriteupNotifications = createSelector(
//     selectAppCoreState,
//     state => state.globalNotifications
// )


////---------------
export const selectAppNotification = createSelector(
    selectAppCoreState,
    state => state.notification
);
//
// 
//
 export const selectHasAppNotification = createSelector(
    selectAppCoreState,
    state => {
        if ( state.notification.notificationsList && state.notification.notificationsList.length > 0){
            if(state.notification.notificationsList.length > 0)
            {
                return true;
            }
        }
        return false;
    }
);
//
//
//
export const selectAppToasts = createSelector(
    selectAppCoreState,
    state => state.notification.toastMessages
);
//
//
//
export const selectAppOnlineStatus = createSelector(
    selectAppCoreState,
    state => state.appStatus.isOnline
);
//
// select app chat
//
export const selectAppChat = createSelector(
    selectAppCoreState,
    state => state.chat
);
//
//
//
export const selectAppChatCurrentDealTransactionId = createSelector(
    selectAppCoreState,
    state => state.chat.currentDealId
);
export const selectAppChatComments = createSelector(
    selectAppCoreState,
    state => state.notification.comments
);

export const getMyTheme = createSelector(
    selectAppCoreState, 
    state => state.AuthAccessData.darkTheme
);